module.exports = __webpack_public_path__ + "static/media/non-vegetarian.935dcf28.svg";